import React from "react";
import { OptionNameValuePair } from "../../../../lib/interfaces/types";
import { cn } from "../../../../lib/utils";
import MultiSelectSummaryDropdown from "../../selectdropdown/v2/MultiSelectSummaryDropdown";

interface IMultiselectCellProps {
  name?: string;
  placeholder?: string;
  value?: string[];
  isEditable?: boolean;
  onChange?: (value: string[]) => void;
  options?: OptionNameValuePair<string>[];
  className?: string;
  chipClassName?: string;
  rootContainerClassName?: string;
  dropdownClassName?: string;
  hideChevron?: boolean;
  showTooltip?: boolean;
  renderCustomView?: (selectedOptions: OptionNameValuePair<string>[]) => React.ReactNode;
}

const MultiselectCell: React.FC<IMultiselectCellProps> = ({
  value = [],
  isEditable,
  onChange,
  options = [],
  className,
  chipClassName,
  rootContainerClassName,
  dropdownClassName,
  placeholder,
  name,
  hideChevron = true,
  showTooltip = true,
  renderCustomView,
}) => {
  const selectedOptions = options?.filter((opt) =>
    value?.includes(opt.value)
  );

  if (!isEditable) {
    if (renderCustomView && selectedOptions && selectedOptions.length > 0) {
      return renderCustomView(selectedOptions);
    }

    const displayText = selectedOptions?.map((opt) => opt.name).join(", ");
    return (
      <div className={cn("px-2 py-1 text-sm", className)}>
        {displayText || "-"}
      </div>
    );
  }

  return (
    <MultiSelectSummaryDropdown
      name={name}
      value={value}
      options={options}
      onChange={onChange}
      placeholder={placeholder}
      enableSearch={true}
      showChipSummary={!renderCustomView}
      showTooltip={showTooltip}
      hideChevronWhenSelected={hideChevron ?? true}
      className={className}
      chipClassName={chipClassName}
      rootContainerClassName={cn(
        "w-full",
        "bg-red",
        "border border-transparent rounded",
        "focus-within:bg-[#F3F4F6] focus-within:border-[#4B5563]",
        rootContainerClassName
      )}
      dropdownClassName={cn("-ml-[10px]", dropdownClassName)}
      searchPlaceholder="Search"
      renderCustomView={
        renderCustomView && selectedOptions && selectedOptions.length > 0
          ? () => renderCustomView(selectedOptions)
          : undefined
      }
    />
  );
};

export default MultiselectCell;
